import * as _ from 'lodash';



export enum BootstrapBreakpoints {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}


export function isNullOrUndefined<T>(val: T): boolean {
  return val === null || typeof val === 'undefined';
}

export function slug(value: string): string {
  return value.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

export function parseEnum<T>(enumObject: object, val: string): T {
  const r = _.findKey(enumObject, k => k === val);
  return enumObject[r] as T;
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/index.ts